export default __webpack_public_path__ + "148e54d92254c8bbf359bed7a7d4454a.png";